import { render, staticRenderFns } from "./role-check.vue?vue&type=template&id=0ba87426&scoped=true&"
import script from "./role-check.vue?vue&type=script&lang=js&"
export * from "./role-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba87426",
  null
  
)

export default component.exports